import thumb1 from "../../images/blog/blog-img.png";
import thumb2 from "../../images/blog/blog-img2.png";
import thumb3 from "../../images/blog/blog-img3.png";
import thumb4 from "../../images/blog/blog-img4.png";
import thumb5 from "../../images/blog/blog-img5.png";
import thumb6 from "../../images/blog/blog-img6.png";
import thumb7 from "../../images/blog/blog-img7.png";
import thumb8 from "../../images/blog/blog-img8.png";
import thumb9 from "../../images/blog/blog-img9.png";

const data = {
  posts: [
    {
      thumbnail: thumb1,
      author: "INNA MOUAZ",
      title: "How to Create Your 1st Crypto NFTs",
      excerpt:
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled",
      timeStamp: "24 FEB, 2022",
      categories: [
        {
          title: "NFT",
          url: "#",
        },
      ],
    },
    {
      thumbnail: thumb2,
      author: "INNA MOUAZ",
      title: "The New World is All about Metaverse",
      excerpt:
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled",
      timeStamp: "24 FEB, 2022",
      categories: [
        {
          title: "GAMMING",
          url: "#",
        },
      ],
    },
    {
      thumbnail: thumb3,
      author: "INNA MOUAZ",
      title: "It’s the Great Chance to Invest in NFT",
      excerpt:
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled",
      timeStamp: "24 FEB, 2022",
      categories: [
        {
          title: "METAVERSE",
          url: "#",
        },
        {
          title: "NFT",
          url: "#",
        },
      ],
    },
    {
      thumbnail: thumb4,
      author: "INNA MOUAZ",
      title: "Why You Should mint NFT in MintO",
      excerpt:
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled",
      timeStamp: "24 FEB, 2022",
      categories: [
        {
          title: "META",
          url: "#",
        },
      ],
    },
    {
      thumbnail: thumb5,
      author: "INNA MOUAZ",
      title: "Make 100% Profite by Minting NFT",
      excerpt:
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled",
      timeStamp: "24 FEB, 2022",
      categories: [
        {
          title: "IGO",
          url: "#",
        },
      ],
    },
    {
      thumbnail: thumb6,
      author: "INNA MOUAZ",
      title: "Sell Your Digital Art on the Martekplace",
      excerpt:
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled",
      timeStamp: "24 FEB, 2022",
      categories: [
        {
          title: "CRYPTO",
          url: "#",
        },
      ],
    },
    {
      thumbnail: thumb7,
      author: "INNA MOUAZ",
      title: "Metaverse Gaming NFT on The Way",
      excerpt:
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled",
      timeStamp: "24 FEB, 2022",
      categories: [
        {
          title: "Metaverse",
          url: "#",
        },
      ],
    },
    {
      thumbnail: thumb8,
      author: "INNA MOUAZ",
      title: "We Publish Our Projects Roadmap",
      excerpt:
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled",
      timeStamp: "24 FEB, 2022",
      categories: [
        {
          title: "NFT",
          url: "#",
        },
        {
          title: "GAMMING",
          url: "#",
        },
      ],
    },
    {
      thumbnail: thumb9,
      author: "INNA MOUAZ",
      title: "Purchase Your 1st Crypto NFTs Here",
      excerpt:
        "On the other hand, we denounce with righteous indignation and dislike men who are so beguiled",
      timeStamp: "24 FEB, 2022",
      categories: [
        {
          title: "crypto",
          url: "#",
        },
      ],
    },
  ],
};

export default data;
